// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_9e1425b4d3--dropdown--X8zry"};